import { useAppSelector } from 'hooks/reduxHooks'
import { getFunnelFeatures } from 'checkout/selectors/funnel'

export function useFunnelFeature(feature: keyof App.FunnelFeatureToggles): boolean {
  return useAppSelector(getFunnelFeatures)[feature]
}
